import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/about/about1/variants/01/about-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/about/about1/variants/02/about-variant-02.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/about/about1/variants/03/about-variant-03.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/ctas/cta-premium1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/ctas/cta1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/FAQ/FAQ1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/floating-whatsapp/floating-whatsapp1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/variants/01/footer-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/variants/04/footer-variant-04.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/store-address/variants/02/footer-store-address-02.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/store-address/variants/03/footer-store-address-03.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/working-hours/variants/01/footer-working-hours-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/working-hours/variants/02/footer-working-hours-02.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/working-hours/variants/03/footer-working-hours-03.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/menu-variants/variants/01/menu-variants-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/menu-variants/variants/03/menu-variants-03.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/socials/variants/01/social-icons.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/socials/variants/02/social-icons-02.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/socials/variants/03/social-icons-03.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/footers/footer1/store-address/variants/01/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/footers/footer1/variants/03/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/logo/logo.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/footers/footer1/variants/05/footer-variant-05.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/forms/form-contact-1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/apps/platforms/components/package-components/editable/header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/heroes/hero1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/heroes/hero2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/datalayer-form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/details-header/variants/01/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/style.css");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/variants/pre-owned/02/details-variant-02.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/information/variants/01/details-information-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/information/variants/02/details-information-variant-02.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["JsonLd"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/json-ld/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/optionals/variants/01/optionals-variant-01.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/optionals/variants/02/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SendGTMEvents"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/send-gtm-events/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandNewVehicleDetailsVariant1"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/variants/brand-new/01/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VehicleDetailsVariant1"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/variants/pre-owned/01/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatsappClientButton"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/details-1/variants/pre-owned/02/whatsapp-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-filter/filter-item/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-filter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-filter/radio-item/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-filter/range-item/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-filter/skeleton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/client-pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyerPreference"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/handle-buyer-preference.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/vehicle-sold/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VehicleContainer"] */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/vehicles-container/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/filter-1/vehile-inventory.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/card/card.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/inventory/vehicles/card/skeleton/skeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/navigation/navigation1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopUpVariant01"] */ "/app/apps/platforms/components/package-components/editable/pop-up/pop-up1/variants/01/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/premium-modules/premium-module1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/01/sw-home-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/03/sw-home-variant-03.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/02/sw-home-variant-02.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SwHomeVariant06"] */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/06/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-makes/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-models/variants/01/sw-models-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-category/variants/01/sw-categories-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-instagram/variants/01/sw-instagram-variant-01.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/privacy-policy/privacy-policy1/privacy-policy.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/opening-hours/opening-hours1/variants/01/opening-hours-variant-01.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SwHomeVariant04"] */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/04/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwHomeVariant05"] */ "/app/apps/platforms/components/package-components/editable/smart-widget/sw-home/variants/05/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/stick-footer/stick-footer1/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/editable/stick-navbar/sticky-navbar.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Loading"] */ "/app/apps/platforms/components/package-components/layout/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeLogo"] */ "/app/apps/platforms/components/package-components/layout/ThemeLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/app/apps/platforms/components/package-components/layout/ThemeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/non-editable/core/platforms-icon/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/core/platforms-image/platforms-image.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/card-variants/variants/01/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/card-variants/variants/02/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/card-variants/variants/03/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/card-variants/variants/04/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/carroussel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentComponent"] */ "/app/apps/platforms/components/package-components/non-editable/misc/CookieConsent.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/components/package-components/non-editable/misc/dots/dots.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platforms/components/package-components/non-editable/misc/vehicle-gallery/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platforms/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryDevtools"] */ "/app/node_modules/@tanstack/react-query-devtools/build/lib/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Hydrate","useHydrate"] */ "/app/node_modules/@tanstack/react-query/build/lib/Hydrate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/lib/isRestoring.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider","defaultContext","useQueryClient"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["unstable_batchedUpdates"] */ "/app/node_modules/@tanstack/react-query/build/lib/reactBatchedUpdates.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsMutating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/lib/useMutation.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQueries.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQuery.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
